import React from 'react';
import DataGrid from '../common/Table/newTable';
import { LineupRubric } from './store/types';
import { lineupTableHeaderConfig } from '../common/Table/LineupBuilderConfig';
import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';


const LineupTable = ({ players, loading }: { players: LineupRubric[], loading: boolean }) => {
  const { selectedSlate } = useSelector((state: any) => state.common);

  return (
    <Stack position='relative' height={'calc(100vh - 400px)'}>
      {/* {
        loading && (
          <Stack justifyContent='center' alignItems='center' position='absolute' height='100%' width="100%" bgcolor='red'>
            Loading
          </Stack>
        )
      } */}
      <DataGrid
        includeStacks={false}
        lineups={players}
        headers={lineupTableHeaderConfig(selectedSlate)}
        isLoading={loading}
        selectedView="lineupTable"
        simType="lineupBuilder"
        setStackView={(view: string) => console.log("")}
        tierlocked={false}
        setPlayerList={() => console.log("")}
        setStackList={() => console.log("")}
        pagination={false}
        rowHeight={40}
        emptyText={"Upload your lineups to start generating."}
        fontSize={14}
        footer={() => <></>}
        projectionModal={() => <></>}
        backgroundColor={'rgba(161, 0, 18, 0.15)'}
        hideToolbar={true}
      />
    </Stack>
  )
}

export default LineupTable